export default __webpack_public_path__ + "static/media/linda.8f9539e2.png";